<table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows>

    <ng-container matColumnDef="ps">
        <th mat-header-cell *matHeaderCellDef class="text-center font10" style="width: .5rem;">PS</th>
        <td mat-cell *matCellDef="let det" class="text-center font10" style="width: .5rem;">
            {{det.ps}} </td>
    </ng-container>

    <ng-container matColumnDef="detFromDt">
        <th mat-header-cell *matHeaderCellDef class="text-center font10" style="width: 6rem;">{{engLang ? 'From':
            'Desde'}}</th>
        <td mat-cell *matCellDef="let det" class="text-center font10" style="width: 6rem;">
            {{det.detFromDt}} </td>
    </ng-container>

    <ng-container matColumnDef="detToDt">
        <th mat-header-cell *matHeaderCellDef class="text-center font10">{{engLang ? 'To': 'Hasta'}}</th>
        <td mat-cell *matCellDef="let det" class="text-center font10">
            {{det.detToDt}} </td>
    </ng-container>

    <ng-container matColumnDef="pcode">
        <th mat-header-cell *matHeaderCellDef class="text-center font10">CPT</th>
        <td mat-cell *matCellDef="let det" class="text-center font10">
            {{det.pcode}} </td>
    </ng-container>

    <ng-container matColumnDef="xpect">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10"> {{engLang ? 'Expected': 'Esperado'}} </th>
        <td mat-cell *matCellDef="let det" class="rtalign font10">
            {{det.xpect ? (makeNum(det.xpect) | currency:'USD':'':'0.2-2') : '0.00'}} </td>
    </ng-container>

    <ng-container matColumnDef="privado">
        <th mat-header-cell *matHeaderCellDef class="rtalign font10"> {{engLang ? 'Patient': 'Privado'}} </th>
        <td mat-cell *matCellDef="let det" class="rtalign font10">
            {{det.privado ? (makeNum(det.privado) | currency:'USD':'':'0.2-2') : '0.00'}} </td>
    </ng-container>

    <ng-container matColumnDef="DetQty">
        <th mat-header-cell *matHeaderCellDef class="text-center font10" style="width: 4rem;"> {{engLang ? 'Qty':
            'Cant'}} </th>
        <td mat-cell *matCellDef="let det" class="text-center font10" style="width: 4rem;">
            {{det.DetQty}} </td>
    </ng-container>

    <ng-container matColumnDef="DetDesc">
        <th mat-header-cell *matHeaderCellDef class="font9" style="width: 17rem;"> {{engLang ? 'Description' :
            'Descripción'}} </th>
        <td mat-cell *matCellDef="let det" class="font10 ellipsis" appTooltipIfCollapsed [matTooltip]="det.DetDesc"
            style="width: 17rem;">
            {{det.DetDesc}} </td>
    </ng-container>

    <ng-container matColumnDef="expandPays"> <!-- Expand Payments Column -->
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length" class="font12">
            <app-rpt-esp-cob-pay [payments]="payments" [engLang]="engLang"></app-rpt-esp-cob-pay>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="det-header-row"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="det-row">
    </tr>

    <tr mat-footer-row *matFooterRowDef="['expandPays']">
    </tr>

</table>